export default __webpack_public_path__ + "static/media/botany.bb6274b2.svg";